import { ShoesState } from 'src/types'

const laceHole = (ctx: CanvasRenderingContext2D | null): void => {
  ctx.beginPath()
  ctx.fillStyle = '#383838'
  ctx.arc(560, 202, 6, 0, 2 * Math.PI)
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  ctx.beginPath()
  ctx.fillStyle = '#383838'
  ctx.arc(502, 232, 6, 0, 2 * Math.PI)
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  ctx.beginPath()
  ctx.fillStyle = '#383838'
  ctx.arc(454, 262, 6, 0, 2 * Math.PI)
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  ctx.beginPath()
  ctx.fillStyle = '#383838'
  ctx.arc(402, 290, 6, 0, 2 * Math.PI)
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  ctx.beginPath()
  ctx.fillStyle = '#383838'
  ctx.arc(347, 308, 6, 0, 2 * Math.PI)
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  ctx.beginPath()
  ctx.fillStyle = '#383838'
  ctx.arc(296, 325, 6, 0, 2 * Math.PI)
  ctx.stroke()
  ctx.fill()
  ctx.closePath()
}

const lace = (ctx: CanvasRenderingContext2D | null, state: ShoesState, x: number, y: number) => {
  if (!ctx) return
  // lace
  ctx.beginPath()
  ctx.fillStyle = state.vampStrap.color
  ctx.lineWidth = 1.0
  ctx.moveTo(374 + x, 285 + y)
  ctx.quadraticCurveTo(384 + x, 285 + y, 394 + x, 295 + y)
  ctx.quadraticCurveTo(407 + x, 301 + y, 410 + x, 289 + y)
  ctx.quadraticCurveTo(405 + x, 276 + y, 393 + x, 273 + y)
  ctx.quadraticCurveTo(375 + x, 274 + y, 374 + x, 285 + y)
  ctx.fill()
  ctx.moveTo(374 + x, 284 + y)
  ctx.quadraticCurveTo(389 + x, 281 + y, 397 + x, 295 + y)
  ctx.stroke()
  ctx.closePath()
}

const aroundLaceThrough = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.vampStrapReinforcement.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(275, 320) //つま先＿左下
  ctx.quadraticCurveTo(268, 354, 268, 352)
  ctx.quadraticCurveTo(428, 310, 491, 283)
  ctx.quadraticCurveTo(512, 272, 527, 256)
  ctx.quadraticCurveTo(531, 248, 552, 244)
  ctx.quadraticCurveTo(606, 220, 606, 220)
  ctx.quadraticCurveTo(632, 207, 621, 187)
  ctx.quadraticCurveTo(608, 170, 590, 164)
  ctx.quadraticCurveTo(569, 161, 549, 172)
  ctx.quadraticCurveTo(497, 223, 426, 258)
  ctx.quadraticCurveTo(354, 297, 275, 320)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.strokeStyle = 'white'
  ctx.lineWidth = 2.5
  ctx.moveTo(271, 351)
  ctx.quadraticCurveTo(333, 330, 378, 321)
  ctx.quadraticCurveTo(429, 307, 485, 286)
  ctx.quadraticCurveTo(505, 278, 522, 261)
  ctx.quadraticCurveTo(530, 247, 550, 244)
  ctx.quadraticCurveTo(579, 235, 613, 215)
  ctx.quadraticCurveTo(634, 200, 612, 178)
  //   ctx.quadraticCurveTo()
  //   ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(274, 347) // 左
  ctx.quadraticCurveTo(337, 327, 337, 327)
  ctx.quadraticCurveTo(395, 316, 489, 278)
  ctx.quadraticCurveTo(511, 270, 526, 251)
  ctx.quadraticCurveTo(538, 240, 555, 238)
  ctx.quadraticCurveTo(579, 232, 615, 208)
  ctx.quadraticCurveTo(621, 203, 616, 191)
  ctx.quadraticCurveTo(606, 175, 578, 173)
  ctx.quadraticCurveTo(557, 171, 540, 190)
  ctx.quadraticCurveTo(458, 252, 460, 249)
  ctx.quadraticCurveTo(401, 280, 353, 300)
  ctx.quadraticCurveTo(281, 325, 277, 325)
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  //   canvasResetter(ctx) // リセット
}
// 紐 x 折りベロ
const aroundLaceThroughWithFoldingTongue = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.vampStrapReinforcement.color
  ctx.lineWidth = 1.0

  // 側面
  ctx.beginPath()
  ctx.moveTo(275, 320) //つま先＿左下
  ctx.quadraticCurveTo(268, 354, 268, 352)
  ctx.quadraticCurveTo(428, 310, 491, 283)
  ctx.quadraticCurveTo(512, 272, 527, 256)
  ctx.quadraticCurveTo(531, 248, 552, 244)
  ctx.quadraticCurveTo(578, 233, 578, 233)
  ctx.quadraticCurveTo(595, 228, 589, 216)
  ctx.quadraticCurveTo(545, 190, 545, 190)
  ctx.quadraticCurveTo(522, 198, 509, 210)
  ctx.quadraticCurveTo(447, 248, 443, 255)
  ctx.quadraticCurveTo(383, 280, 372, 286)
  ctx.quadraticCurveTo(315, 309, 309, 310)
  ctx.quadraticCurveTo(275, 320, 275, 320)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ctx.beginPath()
  // ctx.strokeStyle = 'white'
  // ctx.lineWidth = 2.5
  // ctx.moveTo(271, 351)
  // ctx.quadraticCurveTo(333, 330, 378, 321)
  // ctx.quadraticCurveTo(429, 307, 485, 286)
  // ctx.quadraticCurveTo(505, 278, 522, 261)
  // ctx.quadraticCurveTo(530, 247, 550, 244)
  // ctx.quadraticCurveTo(579, 235, 586, 229)
  // ctx.quadraticCurveTo(594, 226, 588, 216)
  // //   ctx.quadraticCurveTo()
  // ctx.stroke()
  // ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(274, 347) // 左
  ctx.quadraticCurveTo(337, 327, 337, 327)
  ctx.quadraticCurveTo(395, 316, 489, 278)
  ctx.quadraticCurveTo(511, 270, 526, 251)
  ctx.quadraticCurveTo(538, 240, 555, 238)
  ctx.quadraticCurveTo(585, 227, 585, 227)
  ctx.quadraticCurveTo(592, 226, 585, 218)
  ctx.quadraticCurveTo(544, 193, 544, 193)
  ctx.quadraticCurveTo(425, 283, 278, 324)
  ctx.quadraticCurveTo(274, 347, 274, 347)
  // ctx.quadraticCurveTo()

  ctx.moveTo(544, 198) // 左
  ctx.quadraticCurveTo(425, 288, 276, 328)

  // ctx.quadraticCurveTo()

  // ctx.quadraticCurveTo(557, 171, 540, 190)
  // ctx.quadraticCurveTo(458, 252, 460, 249)
  // ctx.quadraticCurveTo(401, 280, 353, 300)
  // ctx.quadraticCurveTo(281, 325, 277, 325)
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'
}

const metalFittingsLeft = (ctx: CanvasRenderingContext2D | null, x: number, y: number): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = 'silver'
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(441 + x, 230 + y) //つま先＿左下
  ctx.quadraticCurveTo(434 + x, 243 + y, 443 + x, 241 + y)
  ctx.quadraticCurveTo(445 + x, 239 + y, 445 + x, 239 + y)
  ctx.quadraticCurveTo(439 + x, 239 + y, 443 + x, 234 + y)
  ctx.quadraticCurveTo(441 + x, 230 + y, 441 + x, 230 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const metalFittingsRight = (ctx: CanvasRenderingContext2D | null, x: number, y: number): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = 'silver'
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(490 + x, 212 + y) //つま先＿左下
  ctx.quadraticCurveTo(494 + x, 209 + y, 491 + x, 216 + y)
  ctx.quadraticCurveTo(493 + x, 217 + y, 493 + x, 217 + y)
  ctx.quadraticCurveTo(502 + x, 210 + y, 490 + x, 207 + y)
  ctx.quadraticCurveTo(490 + x, 212 + y, 490 + x, 212 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// 同方向ベルトパーツ
const beltTapeSameDirection = (ctx: CanvasRenderingContext2D | null, beltColor: string, state: ShoesState, x: number, y: number): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = beltColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(440 + x, 224 + y) //
  ctx.quadraticCurveTo(446 + x, 237 + y, 446 + x, 237 + y)
  ctx.quadraticCurveTo(490 + x, 211 + y, 490 + x, 211 + y)
  ctx.quadraticCurveTo(484 + x, 202 + y, 484 + x, 202 + y)
  ctx.quadraticCurveTo(457 + x, 210 + y, 440 + x, 224 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(445 + x, 224 + y) // 左
  ctx.quadraticCurveTo(449 + x, 234 + y, 449 + x, 234 + y)
  ctx.moveTo(480 + x, 206 + y) // 左
  ctx.quadraticCurveTo(484 + x, 212 + y, 484 + x, 212 + y)
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'
}

// 逆方向ベルトパーツ
const beltTapeReverseDirection = (ctx: CanvasRenderingContext2D | null, beltColor: string, state: ShoesState, x: number, y: number): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = beltColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(375, 258)
  ctx.quadraticCurveTo(377, 278, 377, 278)
  ctx.quadraticCurveTo(383, 289, 429, 271)
  ctx.quadraticCurveTo(435, 263, 433, 260)
  ctx.quadraticCurveTo(431, 257, 420, 235)
  ctx.quadraticCurveTo(396, 242, 375, 258)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(379, 259) // 左
  ctx.quadraticCurveTo(381, 277, 381, 277)
  ctx.quadraticCurveTo(397, 280, 427, 266)
  ctx.quadraticCurveTo(433, 263, 426, 257)
  ctx.quadraticCurveTo(417, 239, 417, 239)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'
}

const aroundBeltThrough = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  // 1段目の金具側
  metalFittingsLeft(ctx, 0, 0)
  metalFittingsRight(ctx, 0, 0)

  // 同方向のベルトタイプであれば、2段目の金具側を描画
  if (state.vampStrapType.value === 'beltTypeSameDirection') {
    metalFittingsLeft(ctx, -66, 30)
    metalFittingsRight(ctx, -68, 34)
  }
  // 3段目の金具側を描画
  metalFittingsLeft(ctx, -132, 62)
  metalFittingsRight(ctx, -136, 65)

  // 折りベロじゃない時、1つ目のベルトパーツを描画
  const belt1Color = state.vampStrapBelt1.color
  if (['standingTongue', 'unselected'].includes(state.tongue.value)) beltTapeSameDirection(ctx, belt1Color, state, 0, 0)
  // 同方向のベルトタイプであれば、2段目の金具側を描画
  const belt2Color = state.vampStrapBelt2.color
  if (state.vampStrapType.value === 'beltTypeSameDirection') beltTapeSameDirection(ctx, belt2Color, state, -69, 34)

  const belt3Color = state.vampStrapBelt3.color
  beltTapeSameDirection(ctx, belt3Color, state, -134, 65) // 3段目の金具側を描画

  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.vampStrapReinforcement.color
  ctx.lineWidth = 1.0

  // 側面
  ctx.beginPath()
  ctx.moveTo(275, 320) //つま先＿左下
  ctx.quadraticCurveTo(268, 354, 268, 352)
  ctx.quadraticCurveTo(428, 310, 491, 283)
  ctx.quadraticCurveTo(512, 272, 527, 256)
  ctx.quadraticCurveTo(531, 248, 552, 244)
  ctx.quadraticCurveTo(578, 233, 578, 233)
  ctx.quadraticCurveTo(595, 228, 589, 216)
  ctx.quadraticCurveTo(545, 190, 545, 190)
  ctx.quadraticCurveTo(522, 198, 509, 210)
  ctx.quadraticCurveTo(498, 222, 490, 216)
  ctx.quadraticCurveTo(492, 211, 492, 211)
  ctx.quadraticCurveTo(442, 240, 442, 240)
  ctx.quadraticCurveTo(447, 248, 443, 251)
  ctx.quadraticCurveTo(442, 257, 434, 257)
  ctx.quadraticCurveTo(424, 257, 422, 246)
  ctx.quadraticCurveTo(375, 267, 375, 267)
  ctx.quadraticCurveTo(380, 276, 372, 282)
  ctx.quadraticCurveTo(358, 291, 354, 280)
  ctx.quadraticCurveTo(310, 298, 310, 298)
  ctx.quadraticCurveTo(313, 306, 309, 310)
  ctx.quadraticCurveTo(275, 320, 275, 320)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ctx.beginPath()
  // ctx.strokeStyle = 'white'
  // ctx.lineWidth = 2.5
  // ctx.moveTo(271, 351)
  // ctx.quadraticCurveTo(333, 330, 378, 321)
  // ctx.quadraticCurveTo(429, 307, 485, 286)
  // ctx.quadraticCurveTo(505, 278, 522, 261)
  // ctx.quadraticCurveTo(530, 247, 550, 244)
  // ctx.quadraticCurveTo(579, 235, 586, 229)
  // ctx.quadraticCurveTo(594, 226, 588, 216)
  // //   ctx.quadraticCurveTo()
  // ctx.stroke()
  // ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(274, 347) // 左
  ctx.quadraticCurveTo(337, 327, 337, 327)
  ctx.quadraticCurveTo(395, 316, 489, 278)
  ctx.quadraticCurveTo(511, 270, 526, 251)
  ctx.quadraticCurveTo(538, 240, 555, 238)
  ctx.quadraticCurveTo(585, 227, 585, 227)
  ctx.quadraticCurveTo(592, 226, 585, 218)
  ctx.quadraticCurveTo(544, 193, 544, 193)
  ctx.quadraticCurveTo(425, 283, 278, 324)
  ctx.quadraticCurveTo(274, 347, 274, 347)
  // ctx.quadraticCurveTo()

  ctx.moveTo(544, 198) // 左
  ctx.quadraticCurveTo(425, 288, 276, 328)

  // ctx.quadraticCurveTo()

  // ctx.quadraticCurveTo(557, 171, 540, 190)
  // ctx.quadraticCurveTo(458, 252, 460, 249)
  // ctx.quadraticCurveTo(401, 280, 353, 300)
  // ctx.quadraticCurveTo(281, 325, 277, 325)
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  if (state.vampStrapType.value === 'beltTypeReverseDirection') {
    const belt2Color = state.vampStrapBelt2.color
    beltTapeReverseDirection(ctx, belt2Color, state, -69, 34)
  }

  //   canvasResetter(ctx) // リセット
}

const aroundBeltThroughForQuarterCut = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  // 1段目の金具側
  metalFittingsLeft(ctx, 0, 0)
  metalFittingsRight(ctx, 0, 0)

  // 同方向のベルトタイプであれば、2段目の金具側を描画
  if (state.vampStrapType.value === 'beltTypeSameDirection') {
    metalFittingsLeft(ctx, -66, 30)
    metalFittingsRight(ctx, -68, 34)
  }
  // 3段目の金具側を描画
  metalFittingsLeft(ctx, -132, 62)
  metalFittingsRight(ctx, -136, 65)

  // 折りベロじゃない時、1つ目のベルトパーツを描画
  const belt1Color = state.vampStrapBelt1.color
  if (['standingTongue', 'unselected'].includes(state.tongue.value)) beltTapeSameDirection(ctx, belt1Color, state, 0, 0)
  // 同方向のベルトタイプであれば、2段目の金具側を描画
  const belt2Color = state.vampStrapBelt2.color
  if (state.vampStrapType.value === 'beltTypeSameDirection') beltTapeSameDirection(ctx, belt2Color, state, -69, 34)

  const belt3Color = state.vampStrapBelt3.color
  beltTapeSameDirection(ctx, belt3Color, state, -134, 65) // 3段目の金具側を描画

  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.vampStrapReinforcement.color
  ctx.lineWidth = 1.0

  // 側面 ... 反時計周りに描画
  ctx.beginPath()
  ctx.moveTo(275, 320) //つま先＿左下
  ctx.quadraticCurveTo(268, 354, 268, 352)
  ctx.quadraticCurveTo(428, 310, 491, 283)
  ctx.quadraticCurveTo(512, 272, 527, 256)
  ctx.quadraticCurveTo(531, 248, 552, 244)
  ctx.quadraticCurveTo(578, 233, 578, 233)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.quadraticCurveTo(616, 216, 616, 216)
  ctx.quadraticCurveTo(639, 203, 611, 176)
  ctx.quadraticCurveTo(590, 158, 568, 167)
  ctx.quadraticCurveTo(545, 190, 545, 190)
  ctx.quadraticCurveTo(522, 198, 509, 210)
  ctx.quadraticCurveTo(498, 222, 490, 216)
  ctx.quadraticCurveTo(492, 211, 492, 211)
  ctx.quadraticCurveTo(442, 240, 442, 240)
  ctx.quadraticCurveTo(447, 248, 443, 251)
  ctx.quadraticCurveTo(442, 257, 434, 257)
  ctx.quadraticCurveTo(424, 257, 422, 246)
  ctx.quadraticCurveTo(375, 267, 375, 267)
  ctx.quadraticCurveTo(380, 276, 372, 282)
  ctx.quadraticCurveTo(358, 291, 354, 280)
  ctx.quadraticCurveTo(310, 298, 310, 298)
  ctx.quadraticCurveTo(313, 306, 309, 310)
  ctx.quadraticCurveTo(275, 320, 275, 320)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ctx.beginPath()
  // ctx.strokeStyle = 'white'
  // ctx.lineWidth = 2.5
  // ctx.moveTo(271, 351)
  // ctx.quadraticCurveTo(333, 330, 378, 321)
  // ctx.quadraticCurveTo(429, 307, 485, 286)
  // ctx.quadraticCurveTo(505, 278, 522, 261)
  // ctx.quadraticCurveTo(530, 247, 550, 244)
  // ctx.quadraticCurveTo(579, 235, 586, 229)
  // ctx.quadraticCurveTo(594, 226, 588, 216)
  // //   ctx.quadraticCurveTo()
  // ctx.stroke()
  // ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(274, 347) // 左
  ctx.quadraticCurveTo(337, 327, 337, 327)
  ctx.quadraticCurveTo(395, 316, 489, 278)
  ctx.quadraticCurveTo(511, 270, 526, 251)
  ctx.quadraticCurveTo(538, 240, 555, 238)
  ctx.quadraticCurveTo(585, 227, 585, 227)
  ctx.quadraticCurveTo(592, 226, 585, 218)
  ctx.quadraticCurveTo(544, 193, 544, 193)
  ctx.quadraticCurveTo(425, 283, 278, 324)
  ctx.quadraticCurveTo(274, 347, 274, 347)
  // ctx.quadraticCurveTo()

  ctx.moveTo(544, 198) // 左
  ctx.quadraticCurveTo(425, 288, 276, 328)

  // ctx.quadraticCurveTo()

  // ctx.quadraticCurveTo(557, 171, 540, 190)
  // ctx.quadraticCurveTo(458, 252, 460, 249)
  // ctx.quadraticCurveTo(401, 280, 353, 300)
  // ctx.quadraticCurveTo(281, 325, 277, 325)
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  if (state.vampStrapType.value === 'beltTypeReverseDirection') {
    const belt2Color = state.vampStrapBelt2.color
    beltTapeReverseDirection(ctx, belt2Color, state, -69, 34)
  }

  //   canvasResetter(ctx) // リセット
}

// ctx.beginPath()
// ctx.moveTo(0, 0)
// ctx.quadraticCurveTo(0, 0, 0, 0)
// ctx.closePath()

export const vampStrapReinforcement = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  const vampStrapType = state.vampStrapType.value

  if (['laceType', 'unselected'].includes(vampStrapType)) {
    const openingPattern = state.openingPattern.value
    if (openingPattern === 'quarterCut') {
      aroundLaceThrough(ctx, state)
      laceHole(ctx)
      lace(ctx, state, -100, 37)
      lace(ctx, state, -50, 19)
      lace(ctx, state, 0, 0)
      lace(ctx, state, 52, -28)
      lace(ctx, state, 98, -55)
      return
    }
    if (['lowCut', 'mountainMiddleCut', 'horizontalMiddleCut', 'unselected'].includes(openingPattern)) {
      aroundLaceThroughWithFoldingTongue(ctx, state)
      ctx.beginPath()
      ctx.fillStyle = '#383838'
      ctx.arc(535, 222, 6, 0, 2 * Math.PI)
      ctx.stroke()
      ctx.fill()
      ctx.closePath()

      lace(ctx, state, -100, 37)
      lace(ctx, state, -50, 19)
      lace(ctx, state, 0, 0)
      lace(ctx, state, 52, -28)
      lace(ctx, state, 98, -55)
      return
    }
  }

  if (['beltTypeSameDirection', 'beltTypeReverseDirection'].includes(vampStrapType)) {
    const openingPattern = state.openingPattern.value

    if (openingPattern === 'quarterCut') {
      aroundBeltThroughForQuarterCut(ctx, state)
      // ここにクォーターカットの描画処理を書く
    }
    if (['lowCut', 'mountainMiddleCut', 'horizontalMiddleCut', 'unselected'].includes(openingPattern)) {
      aroundBeltThrough(ctx, state)
    }
  }
}
